export default {

    initLanguage(state, value) {
        state.language = value;
    },

    // 存入系统菜单
    initSidebarMenuData(state, value) {
        state.sidebarMenuData = value;
    },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js